import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { EnquiryService } from 'src/app/services/Enquiry/enquiry.service';
import { SharedRoutingModule } from 'src/app/shared/shared-routing.module';

@Component({
  selector: 'app-enquiry-type',
  templateUrl: './enquiry-type.component.html',
  styleUrls: ['./enquiry-type.component.css']
})
export class EnquiryTypeComponent implements OnInit {

  EnquiryTypeModel = {
    EnquiryTypeID: 0,
    EnquiryType: '',
    IsActive: true,
    PersonTypeID:0,
    };

    Submitted:boolean;
    EnquiryTypeList:any;
    PersonTypeList:any;

  constructor(private enquiryService: EnquiryService, private LookupService: LookupService, public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.Submitted=false;
    this.GetPersonType();
    this.GetAllEnquiryType();
  }

  


    Clear () {
       this.EnquiryTypeModel.EnquiryType = '';
        this.EnquiryTypeModel.EnquiryTypeID = 0;
       this.EnquiryTypeModel.PersonTypeID = 0;
       this.Submitted = false;
    };

    EnquiryTypeMarkActive (item) {
        this.EnquiryTypeModel.EnquiryTypeID = item.EnquiryTypeID;
      this.EnquiryTypeModel.IsActive = item.IsActive == true ? false : true;
        this.enquiryService.EnquiryTypeMarkActive(JSON.stringify(this.EnquiryTypeModel)).subscribe((data: any) => {
            this.GetAllEnquiryType();          
            this.globalHelper.CheckActionStatus(data);
        });
    }

    Validation() {
        return this.EnquiryTypeModel.PersonTypeID == 0;
    }

  SaveEnquiryType (valid) {
        this.Submitted = true;
        if (valid && !this.Validation()) {
          this.spinnerService.show();
           this.enquiryService.SaveEnquiryType(JSON.stringify(this.EnquiryTypeModel)).subscribe((data: any) => {
            
              if (this.EnquiryTypeModel.EnquiryTypeID == 0 && data.webResponse.Status) {
                    this.Clear();
                }
                this.GetAllEnquiryType();
                this.globalHelper.CheckActionStatus(data);
                this.spinnerService.hide();

            });
        }
    };

    GetAllEnquiryType  () {
      this.spinnerService.show();
       this.enquiryService.GetAllEnquiryType().subscribe((data: any) =>  {
            this.EnquiryTypeList = data.EnquiryTypeList;
            this.globalHelper.CheckActionStatus(data);
            this.spinnerService.hide();
        });
    };


    Edit(obj) {
      this.EnquiryTypeModel.EnquiryTypeID=obj.EnquiryTypeID;
      this.EnquiryTypeModel.EnquiryType = obj.EnquiryType;
       this.EnquiryTypeModel.PersonTypeID = obj.PersonTypeID;
      
};

GetPersonType() {
    this.LookupService.GetLookupsList('EnqPersonType', '').subscribe((data: any) =>{
        this.PersonTypeList = data.LookupItems;
    });
};


}
